import React from 'react';
import styled from 'styled-components';

interface AvatarProps {
  name: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const AvatarContainer = styled.div<{ size: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--color-green);
  color: white;
  font-weight: 600;
  width: ${props => {
    switch (props.size) {
      case 'small': return '32px';
      case 'large': return '48px';
      default: return '40px';
    }
  }};
  height: ${props => {
    switch (props.size) {
      case 'small': return '32px';
      case 'large': return '48px';
      default: return '40px';
    }
  }};
  font-size: ${props => {
    switch (props.size) {
      case 'small': return '12px';
      case 'large': return '18px';
      default: return '16px';
    }
  }};
`;

// Function to get initials from name
const getInitials = (name: string): string => {
  if (!name || name.trim() === '') return 'U';
  
  const parts = name.trim().split(' ');
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({ name, size = 'medium', className }) => {
  const initials = getInitials(name);
  
  return (
    <AvatarContainer 
      size={size} 
      className={className}
      title={name}
    >
      {initials}
    </AvatarContainer>
  );
};

export default Avatar;
